<template>
  <div class="map-container">
    <div id="map"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

export default {
  name: "Map",
  props: {
    data: {
      type: Object,
      default: () => [],
    },
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoibWluZ3lhbjIxNCIsImEiOiJja2h4Y2xiajAwMTBsMnZuNHBzMjVmYjlsIn0.w7Wxvvi2i4olHVL2gE1zkQ",
      map: null,
      markers: [],
    };
  },
  watch: {
    data: {
      handler() {
        console.log(this.data);
        this.init();
      },
    },
  },
  mounted() {
    mapboxgl.accessToken = this.accessToken;
    setTimeout(() => {
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/light-v10",
        center: [127.696, 34.945],
        zoom: 2,
      });
      this.map.on("idle", function () {
        map.resize();
      });
    }, 1000);
  },
  methods: {
    init() {
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/light-v10",
        center: [127.696, 34.945],
        zoom: 2,
      });
      this.map.setMaxZoom(5); // Adjust the maximum zoom level as needed
      var arrLatLong = [];
      var arrMaker = [];

      if (this.data.route_data.route.length == 1) {
        arrLatLong = this.data.route_data.route[0].path?.map(function (item) {
          return item.map((item2) => {
            return Number(item2.toFixed(3));
          });
        });
        arrMaker.push(arrLatLong[0]);
        arrMaker.push(arrLatLong[arrLatLong.length - 1]);
      }

      // đảo ngược phần từ trong array 0 qua 1 1 qua 0
      arrLatLong.forEach((item) => {
        item.reverse();
      });
      const lineString = {
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: arrLatLong,
        },
      };

      this.map.on("load", () => {
        this.map.addSource("line", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [lineString],
          },
        });

        this.map.addLayer({
          id: "line",
          type: "line",
          source: "line",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#0088FF",
            "line-width": 6,
          },
        });

        this.map.addControl(
          new mapboxgl.NavigationControl({
            visualizePitch: false,
            showCompass: false,
          }),
          "bottom-right"
        );

        this.map.addControl(
          new mapboxgl.ScaleControl({
            maxWidth: 100,
            unit: "metric",
          })
        );
        if (this.markers.length > 0) {
          this.markers.forEach((marker) => {
            marker.remove();
          });
          this.markers = [];
        }

        if (arrMaker) {
          this.markers = arrMaker.map((feature, idx) => {
            const el = document.createElement("div");
            if (idx != arrMaker.length - 1) {
              el.className = "marker";

              el.style.background = "#28938D";
              var imgElement = document.createElement("img");
              imgElement.src =
                "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjUuMzI0MDQiIGN5PSI1LjMyNDA0IiByPSI0LjY1ODU0IiBmaWxsPSIjMDEzOUZGIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuMzMxMDEiLz4KPC9zdmc+";
              el.appendChild(imgElement);
            } else {
              el.style.background = "#28938D";
              el.className = "hFBIkY";

              var imgElement = document.createElement("img");
              imgElement.src =
                "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgogICAgICAgIDxwYXRoIGQ9Ik03LjI1MTc4IDMuMzMyMDFMNy43NDczMiAyLjg0MjZDNy43OTYyMiAyLjc5MzQ5IDcuODU0OTMgMi43NTQ0MSA3LjkxOTk0IDIuNzI3NzFDNy45ODQ5NCAyLjcwMTAxIDguMDU0ODggMi42ODcyNSA4LjEyNTU1IDIuNjg3MjVDOC4xOTYyMyAyLjY4NzI1IDguMjY2MTcgMi43MDEwMSA4LjMzMTE3IDIuNzI3NzFDOC4zOTYxNyAyLjc1NDQxIDguNDU0ODkgMi43OTM0OSA4LjUwMzc5IDIuODQyNkwxMi44NDI2IDcuMTI1MjlDMTIuOTQzNCA3LjIyNTQ4IDEyLjk5OTggNy4zNTk0NiAxMi45OTk4IDcuNDk4OTFDMTIuOTk5OCA3LjYzODM1IDEyLjk0MzQgNy43NzIzNCAxMi44NDI2IDcuODcyNTJMOC41MDM3OSAxMi4xNTcxQzguNDU0ODkgMTIuMjA2MyA4LjM5NjE3IDEyLjI0NTMgOC4zMzExNyAxMi4yNzJDOC4yNjYxNyAxMi4yOTg3IDguMTk2MjMgMTIuMzEyNSA4LjEyNTU1IDEyLjMxMjVDOC4wNTQ4OCAxMi4zMTI1IDcuOTg0OTQgMTIuMjk4NyA3LjkxOTk0IDEyLjI3MkM3Ljg1NDkzIDEyLjI0NTMgNy43OTYyMiAxMi4yMDYzIDcuNzQ3MzIgMTIuMTU3MUw3LjI1MTc4IDExLjY2NzlDNy4xNDk5OSAxMS41NjYgNy4wOTM4OCAxMS40Mjk3IDcuMDk1NTUgMTEuMjg4M0M3LjA5NzIyIDExLjE0NjkgNy4xNTY1MyAxMS4wMTE4IDcuMjYwNzEgMTAuOTEyMUw5Ljk1MDIyIDguMzgwODRIMy41MzU3MUMzLjIzODg0IDguMzgwODQgMyA4LjE0NDUxIDMgNy44NTE2OFY3LjE0NjU2QzMgNi44NTMzIDMuMjM4ODQgNi42MTc0IDMuNTM1NzEgNi42MTc0SDkuOTUwMjJMNy4yNjA3MSA0LjA4ODA1QzcuMTU1NTIgMy45ODg4OSA3LjA5NTQ5IDMuODUzNjIgNy4wOTM4MiAzLjcxMTkxQzcuMDkyMTQgMy41NzAyMSA3LjE0ODk2IDMuNDMzNjYgNy4yNTE3OCAzLjMzMjIzVjMuMzMyMDFaIiBmaWxsPSIjRkZGIi8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjEwIiBoZWlnaHQ9IjExIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMgMTMpIHJvdGF0ZSgtMTgwKSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPg==";
              function degreesToRadians(degrees) {
                return degrees * (Math.PI / 180);
              }

              function calculateBearing(coord1, coord2) {
                const lat1 = degreesToRadians(coord1[0]);
                const lon1 = degreesToRadians(coord1[1]);
                const lat2 = degreesToRadians(coord2[0]);
                const lon2 = degreesToRadians(coord2[1]);

                const deltaLon = lon2 - lon1;

                const x = Math.sin(deltaLon) * Math.cos(lat2);
                const y =
                  Math.cos(lat1) * Math.sin(lat2) -
                  Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLon);

                const bearing = Math.atan2(x, y);
                const bearingDegrees = ((bearing * 180) / Math.PI + 360) % 360;

                return bearingDegrees;
              }

              function calculateOverallDirection(waypoints) {
                const rotations = [];
                for (let i = 0; i < waypoints.length - 1; i++) {
                  const rotation = calculateBearing(
                    waypoints[i],
                    waypoints[i + 1]
                  );
                  rotations.push(rotation);
                }

                // Calculate the average rotation angle
                const averageRotation =
                  rotations.reduce((sum, rotation) => sum + rotation, 0) /
                  rotations.length;

                return averageRotation;
              }

              // Example waypoints
              const waypoints = arrLatLong;

              // Calculate the overall direction
              const overallDirection = calculateOverallDirection(waypoints);
              imgElement.style.rotate = `${overallDirection}deg`;

              el.appendChild(imgElement);
            }

            const location = this.data.locations.find(
              (loc) =>
                Number(loc.lng).toFixed(3) == Number(feature[0]).toFixed(3)
            );
            // create the popup
            const popup = this.featurePopup(location);
            return new mapboxgl.Marker(el)
              .setLngLat(feature)
              .setPopup(popup)
              .addTo(this.map);
          });
        }
      });
    },
    featurePopup(payload) {
      return new mapboxgl.Popup({ offset: 25 }).setHTML(`
        <div >
            <div class='feature-title font-weight-bold mt-1'>${payload.name}, ${payload.country_code}</div>
        </div>
        `);
    },
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
  },
};
</script>

<style>
/* Add custom styles here if needed */

.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
}
.marker {
  display: flex;

  width: 12px;
  height: 12px;
  transform: translate3d(845px, 591px, 0px);
  z-index: 591;
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 100rem;
  color: var(--tc-palette-white);
  justify-content: center;
  position: relative;
  z-index: 2;
}

.marker:after {
  background: transparent;
  border-radius: 10rem;
  content: "";
  height: calc(var(--rem-base) * 4);
  opacity: 1;
  overflow: hidden;
  position: absolute;
  transform: translateZ(0);
  width: calc(var(--rem-base) * 4);
  will-change: transform;
  z-index: 0;
}
.mapboxgl-popup-content .list-group-item {
  padding: 0.5rem 0.25rem;
}
.mapboxgl-popup-content .list-group-item .label {
  padding-right: 0.5rem;
  font-weight: bold;
}

.hFBIkY {
  align-items: center;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
}
.B36fNw .hFBIkY:after,
.B36fNw .hFBIkY:before {
  border-radius: 50%;
  content: "";
  position: absolute;
}
.B36fNw .hFBIkY:before {
  background-color: #08f;
  height: 40px;
  opacity: 0.2;
  width: 40px;
}
.B36fNw .hFBIkY:after {
  border: 2px solid var(--tc-palette-white);
  height: calc(var(--rem-base) * 2);
  opacity: 1;
  overflow: hidden;
  padding: calc(var(--rem-base) * 0.8);
  width: calc(var(--rem-base) * 2);
  z-index: 8;
}
</style>
